import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from '@trg/utils';

export interface SnackbarOptions {
  message: string;
  duration?: number;
}

export interface SnackbarState {
  isSnackbarOpen: boolean;
  snackbarOptions: SnackbarOptions | null;
  lastSnackbarTimer: NodeJS.Timeout | null;
}

export interface SnackbarAction {
  openSnackbar: (message: string, duration?: number) => void;
  closeSnackbar: () => void;
}

export type SnackbarStore = SnackbarState & SnackbarAction;

const useSnackbarStoreBase = create<SnackbarStore>()(
  devtools(
    (set, get) => ({
      isSnackbarOpen: false,
      snackbarOptions: null,
      lastSnackbarTimer: null,
      openSnackbar(message, duration = 2000) {
        const { lastSnackbarTimer } = get();
        lastSnackbarTimer && clearTimeout(lastSnackbarTimer);

        set({
          isSnackbarOpen: true,
          snackbarOptions: { message, duration },
          lastSnackbarTimer: setTimeout(() => {
            set({ isSnackbarOpen: false, snackbarOptions: null });
          }, duration),
        });
      },
      closeSnackbar() {
        set({ isSnackbarOpen: false, snackbarOptions: null });
      },
    }),
    {
      name: 'snackbar',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
);

export const useSnackbarStore = createSelectors(useSnackbarStoreBase);
